module.exports = __webpack_public_path__ + "img/lista_numerica.e7b93761.svg";